import { FormattedMessage as FM, useIntl } from "react-intl";

import ListError from "./ListError";
import { STYLE_ACTION_BUTTON } from "../constants";

function ListDeleteConfirm({ item, config, removing, error, onCancel, onConfirm }) {
  const intl = useIntl();
  const name =
    item[config.titleField] ||
    intl.formatMessage({ id: "melhous.dash.list.untitled" });
  return (
    <div className="mt-3 space-y-2 border-t border-neutral-200 pt-3">
      <p className="text-sm text-neutral-800">
        <FM id="melhous.dash.list.delete_confirm" values={{ name }} />
      </p>
      <ListError error={error} />
      <div className="flex justify-end gap-2">
        <button
          type="button"
          disabled={removing}
          onClick={onCancel}
          className={`${STYLE_ACTION_BUTTON} min-h-11 disabled:opacity-50`}
        >
          <FM id="melhous.dash.list.cancel" />
        </button>
        <button
          type="button"
          disabled={removing}
          onClick={onConfirm}
          className="min-h-11 rounded-md bg-red-700 px-3 py-2 text-sm font-medium text-white hover:bg-red-800 disabled:opacity-50"
        >
          <FM
            id={
              removing
                ? "melhous.dash.list.deleting"
                : "melhous.dash.list.delete"
            }
          />
        </button>
      </div>
    </div>
  );
}

export default ListDeleteConfirm;
